function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import * as React from 'react';
import PropTypes from 'prop-types';
import { onlyUpdateForKeys } from 'recompose';
import { StyleSheet, css, color, transition, zIndex } from "../../styles/theme";
import { ToggleCheckBoxOutlineBlank, ToggleCheckBox, ToggleRadioButtonChecked, ToggleRadioButtonUnchecked, ToggleIndeterminateCheckBox } from "../../svg";
export var LABEL_POSITION = {
  left: 'left',
  right: 'right'
};
var getFocusedStateStyles = function getFocusedStateStyles() {
  var outlineColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : color.primaryText;
  return StyleSheet.create({
    focused: {
      outline: "solid 2px ".concat(outlineColor),
      borderRadius: '2px'
    }
  });
};
var styles = StyleSheet.create({
  Checkbox: {
    'marginBottom': 0,
    'whiteSpace': 'nowrap',
    'outline': 'none',
    'display': 'inline-flex',
    'position': 'relative',
    'lineHeight': 1,
    'verticalAlign': 'middle',
    'alignItems': 'center',
    ':hover': {
      borderColor: color.primary,
      color: color.primary
    },
    ':focus': {
      outline: 'auto',
      color: color.primary
    }
  },
  active: {
    cursor: 'pointer'
  },
  readOnly: {
    ':hover': {
      borderColor: color.divider,
      color: color.primaryText
    },
    ':focus': {
      borderColor: color.divider,
      color: color.primaryText
    }
  },
  interactiveStyle: {},
  disabled: {
    color: color.secondaryText
  },
  btn: {
    'padding': '0.7rem 2rem',
    'border': "1px solid ".concat(color.divider),
    'minWidth': 72,
    ':hover': {
      color: color.primary,
      borderColor: color.primary
    }
  },
  btnChecked: {
    color: color.primary,
    borderColor: color.primary
  },
  btnDisabled: {
    'color': color.secondaryText,
    'backgroundColor': color.bgGray,
    ':hover': {
      borderColor: color.divider,
      color: color.secondaryText
    },
    ':focus': {
      outline: 'auto',
      color: color.secondaryText
    }
  },
  btnDisabledChecked: {
    'color': color.secondaryText,
    'backgroundColor': color.disabled,
    'borderColor': color.divider,
    ':hover': {
      borderColor: color.divider,
      color: color.secondaryText
    },
    ':focus': {
      outline: 'auto',
      color: color.secondaryText
    }
  },
  btnReadOnlyChecked: {
    ':hover': {
      borderColor: color.primary,
      color: color.primary
    }
  },
  iconContainer: {
    display: 'inline-block',
    transition: transition.easeOut('450ms', 'color, fill')
  },
  input: {
    'position': 'absolute',
    'left': 0,
    'top': 0,
    'bottom': 0,
    'right': 0,
    'width': '100%',
    'height': '100%',
    'zIndex': zIndex.lg,
    'opacity': 0,
    ':focus': {
      outline: 'auto'
    }
  },
  flex1: {
    flex: 1
  },
  isFullWidth: {
    width: '100%'
  }
});
var CheckboxBase = /*#__PURE__*/function (_React$PureComponent) {
  function CheckboxBase(props) {
    var _this;
    _classCallCheck(this, CheckboxBase);
    _this = _callSuper(this, CheckboxBase, [props]);
    _defineProperty(_this, "_uncheckedColor", void 0);
    _defineProperty(_this, "_uncheckedHoverColor", void 0);
    _defineProperty(_this, "_checkedColor", void 0);
    _defineProperty(_this, "_checkedHoverColor", void 0);
    _defineProperty(_this, "_disabledColor", void 0);
    _defineProperty(_this, "onChange", function (e) {
      if (_this.props.readOnly) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var checked = e.target.checked;
      // Set the state with onChange callback after that
      _this.setState(function (prevState) {
        return {
          indeterminate: false,
          checked: checked
        };
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange({
            target: _objectSpread(_objectSpread({}, _this.props), {}, {
              value: _this.props.value,
              checked: checked
            }),
            stopPropagation: function stopPropagation() {
              e.stopPropagation();
            },
            preventDefault: function preventDefault() {
              e.preventDefault();
            }
          });
        }
      });
    });
    _defineProperty(_this, "onFocus", function (e) {
      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
      _this.setState({
        focused: true
      });
    });
    _defineProperty(_this, "onBlur", function (e) {
      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
      _this.setState({
        focused: false
      });
    });
    _defineProperty(_this, "onMouseLeave", function () {
      _this.setState({
        hovered: false
      });
    });
    _defineProperty(_this, "onMouseEnter", function () {
      _this.setState({
        hovered: true
      });
    });
    var uncheckedColor = props.uncheckedColor,
      uncheckedHoverColor = props.uncheckedHoverColor,
      checkedColor = props.checkedColor,
      checkedHoverColor = props.checkedHoverColor,
      disabledColor = props.disabledColor,
      isThemeDark = props.isThemeDark;
    _this._uncheckedColor = uncheckedColor || color["secondaryText".concat(isThemeDark ? 'ThemeDark' : '')];
    _this._uncheckedHoverColor = uncheckedHoverColor || color.primary;
    _this._checkedColor = checkedColor || color.primary;
    _this._checkedHoverColor = checkedHoverColor || color.darkPrimary;
    _this._disabledColor = disabledColor || color["disabled".concat(isThemeDark ? 'ThemeDark' : '')];
    _this.state = {
      indeterminate: !!props.indeterminate,
      checked: !!props.checked,
      hovered: false,
      focused: false
    };
    return _this;
  }
  _inherits(CheckboxBase, _React$PureComponent);
  return _createClass(CheckboxBase, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('checked' in nextProps && nextProps.checked !== this.state.checked) {
        this.setState({
          checked: nextProps.checked
        });
      }
      if ('indeterminate' in nextProps && nextProps.indeterminate !== this.state.indeterminate) {
        this.setState({
          indeterminate: nextProps.indeterminate
        });
      }
      if ('checkedColor' in nextProps && nextProps.checkedColor && nextProps.checkedColor !== this._checkedColor) {
        this._checkedColor = nextProps.checkedColor;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        htmlAttributes = _this$props.htmlAttributes,
        isFullWidth = _this$props.isFullWidth,
        isRadio = _this$props.isRadio,
        isRadioButton = _this$props.isRadioButton,
        labelPosition = _this$props.labelPosition,
        name = _this$props.name,
        readOnly = _this$props.readOnly,
        size = _this$props.size,
        style = _this$props.style,
        tabIndex = _this$props.tabIndex,
        value = _this$props.value,
        ariaLabel = _this$props.ariaLabel,
        inputHtmlAttributes = _this$props.inputHtmlAttributes;
      var hovered = this.state.hovered;
      var checked = 'checked' in this.props ? this.props.checked : this.state.checked;
      var indeterminate = 'indeterminate' in this.props ? this.props.indeterminate : this.state.indeterminate;
      var Tag;
      var iconColor = checked ? this._checkedColor : this._uncheckedColor;
      var iconHoverColor = checked ? this._checkedHoverColor : this._uncheckedHoverColor;
      if (disabled) {
        iconColor = this._disabledColor;
        iconHoverColor = this._disabledColor;
      } else if (readOnly && !checked) {
        iconColor = this._uncheckedColor;
        iconHoverColor = this._uncheckedColor;
      }
      if (indeterminate) {
        Tag = ToggleIndeterminateCheckBox;
      } else if (isRadio) {
        Tag = checked ? ToggleRadioButtonChecked : ToggleRadioButtonUnchecked;
      } else {
        Tag = checked ? ToggleCheckBox : ToggleCheckBoxOutlineBlank;
      }
      var checkboxElement = /*#__PURE__*/React.createElement("span", css(styles.iconContainer, this.state.focused && getFocusedStateStyles(iconColor).focused), /*#__PURE__*/React.createElement(Tag, {
        size: size,
        color: iconColor,
        hoverColor: iconHoverColor,
        hovered: hovered,
        suppressTitle: true
      }));
      var type = isRadio ? 'radio' : 'checkbox';
      return /*#__PURE__*/React.createElement("label", _extends({}, css(styles.Checkbox, 'cui-Checkbox', checked && 'cui-isChecked', isRadioButton && styles.btn, isRadioButton && checked && styles.btnChecked, isRadioButton && disabled && styles.btnDisabled, isRadioButton && checked && disabled && styles.btnDisabledChecked, readOnly && styles.readOnly, isRadioButton && checked && readOnly && styles.btnReadOnlyChecked, !disabled && !readOnly && styles.active, !disabled && !readOnly && 'cui-active', isFullWidth && styles.isFullWidth), htmlAttributes, {
        style: style,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }), labelPosition === LABEL_POSITION.right && !isRadioButton && checkboxElement, /*#__PURE__*/React.createElement("input", _extends({}, css(styles.input, !disabled && !readOnly && styles.active), inputHtmlAttributes, {
        value: value,
        name: name,
        type: type,
        "aria-label": ariaLabel,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        checked: checked,
        onClick: this.props.onClick,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onChange: this.onChange
      })), children && /*#__PURE__*/React.createElement("span", css('p-x-1s font-weight-normal', styles.flex1, disabled && styles.disabled), children), labelPosition === LABEL_POSITION.left && !isRadioButton && checkboxElement);
    }
  }]);
}(React.PureComponent);
_defineProperty(CheckboxBase, "propTypes", {
  htmlAttributes: PropTypes.object,
  name: PropTypes.string,
  children: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
  style: PropTypes.object,
  labelPosition: PropTypes.oneOf(Object.keys(LABEL_POSITION)),
  tabIndex: PropTypes.number,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  // isRadio uses svg icon and isRadioButton uses secondary Button
  isRadio: PropTypes.bool,
  isRadioButton: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  checked: PropTypes.bool,
  size: PropTypes.number,
  isThemeDark: PropTypes.bool,
  // If true, it will overwrite isChecked
  // As soon as user starts to interact, it will set to false
  indeterminate: PropTypes.bool,
  uncheckedColor: PropTypes.string,
  uncheckedHoverColor: PropTypes.string,
  checkedColor: PropTypes.string,
  checkedHoverColor: PropTypes.string,
  disabledColor: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  /**
   * Can be used to quickly set label for screen readers
   */
  ariaLabel: PropTypes.string,
  /**
   * Allows to pass custom input props
   */
  inputHtmlAttributes: PropTypes.object
});
_defineProperty(CheckboxBase, "defaultProps", {
  style: {},
  htmlAttributes: {},
  size: 24,
  tabIndex: 0,
  labelPosition: 'right',
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
});
export default onlyUpdateForKeys(['onChange', 'checked', 'indeterminate', 'disabled', 'value', 'children', 'checkedColor'])(CheckboxBase);